const formatPoints = (data) => {
  if (Array.isArray(data) && data.length > 0 && data[0].points) {
    return Number(data[0].points).toLocaleString('fr-CA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return '0,00';
};

const PointCard = ({ title, data, footer, icon = 'fa-chart-line', accent = 'blue' }) => {
  const loading = !Array.isArray(data);

  return (
    <article className={`kpi-card kpi-card-${accent}`}>
      <div className="kpi-card-top">
        <span className="kpi-card-icon" aria-hidden="true">
          <i className={`fas ${icon}`}></i>
        </span>
        <h3 className="kpi-card-title">{title}</h3>
      </div>
      {loading ? (
        <div className="kpi-card-skeleton" aria-hidden="true" />
      ) : (
        <p className="kpi-card-value">{formatPoints(data)}</p>
      )}
      <p className="kpi-card-footer">{footer}</p>
    </article>
  );
};

export default PointCard;
